module.exports = __webpack_public_path__ + "static/media/Starlink-logo.764f5751.png";